"use strict";

const upsellModalFilterModule = (function () {
    const init = (container) => {
        if (!container) return;

        const list = container.querySelector('[data-incremental-pricing]');
        if (!list) return;

        const filterBar = container.querySelector('[data-upsell-filter-bar]');
        const pills = filterBar ? Array.from(filterBar.querySelectorAll('[data-upsell-filter-pill]')) : [];
        const sortSelect = container.querySelector('[data-upsell-sort]');
        const items = Array.from(list.querySelectorAll('li[data-package-type]'));
        const separator = list.querySelector('[data-current-package-separator]');

        const activeTypes = new Set();

        const getAllPill = () => pills.find(pill => pill.dataset.upsellFilterPill === 'all');

        const setPressed = (pill, isPressed) => {
            pill.setAttribute('aria-pressed', isPressed ? 'true' : 'false');
        };

        const applyFilter = () => {
            items.forEach(item => {
                const type = item.dataset.packageType;
                const isVisible = activeTypes.size === 0 || activeTypes.has(type);
                if (isVisible) {
                    item.removeAttribute('hidden');
                } else {
                    item.setAttribute('hidden', 'hidden');
                }
            });
        };

        const parseNumber = (value, fallback) => {
            const parsed = parseFloat(value);
            return Number.isNaN(parsed) ? fallback : parsed;
        };

        const getSortComparator = (sortValue) => {
            if (sortValue === 'price') {
                return (a, b) => parseNumber(a.dataset.price, Infinity) - parseNumber(b.dataset.price, Infinity);
            }
            if (sortValue === 'departure') {
                return (a, b) => (a.dataset.departureDate || '').localeCompare(b.dataset.departureDate || '');
            }
            return (a, b) => parseNumber(a.dataset.nights, 0) - parseNumber(b.dataset.nights, 0);
        };

        const applySort = () => {
            const sortValue = sortSelect ? sortSelect.value : 'duration';
            const visibleItems = items.filter(item => !item.hasAttribute('hidden'));

            const currentPackage = visibleItems.find(item => item.dataset.currentPackage === 'true');
            const rest = visibleItems.filter(item => item !== currentPackage);

            rest.sort(getSortComparator(sortValue));

            if (currentPackage) {
                list.appendChild(currentPackage);
            }

            if (separator) {
                const showSeparator = currentPackage && rest.length > 0;
                if (showSeparator) {
                    list.appendChild(separator);
                    separator.removeAttribute('hidden');
                } else {
                    separator.setAttribute('hidden', 'hidden');
                }
            }

            rest.forEach(item => list.appendChild(item));
        };

        const refresh = () => {
            applyFilter();
            applySort();
        };

        const handlePillClick = (pill) => {
            const key = pill.dataset.upsellFilterPill;
            const allPill = getAllPill();

            if (key === 'all') {
                activeTypes.clear();
                pills.forEach(p => setPressed(p, p.dataset.upsellFilterPill === 'all'));
                refresh();
                return;
            }

            if (activeTypes.has(key)) {
                activeTypes.delete(key);
                setPressed(pill, false);
            } else {
                activeTypes.add(key);
                setPressed(pill, true);
            }

            if (allPill) {
                setPressed(allPill, activeTypes.size === 0);
            }

            refresh();
        };

        pills.forEach(pill => {
            pill.addEventListener('click', () => handlePillClick(pill));
        });

        if (sortSelect) {
            sortSelect.addEventListener('change', applySort);
        }

        refresh();
    };

    return {
        init
    };
})();

export default upsellModalFilterModule;
